import React, { useContext } from "react";
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import axios from "axios";
import { getCookie } from "../jwt/_helpers/cookie";
import { sendAuditEvent } from "../utils/auditTrail";
import TenantContext from "../utils/tenantContext";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const ModalConfirm = ({
  openModal,
  setToggleModal,
  title,
  dataModal,
  setRedirect,
  body,
  setError,
  submitFormCustom,
  setSuccess,
  onSuccess,
  apiURL,
  method = "POST",
  auditEventType = null,
  auditRoute = null,
  auditMetadata = null,
}) => {
  const tokenAPI = getCookie("token");
  const { tenant } = useContext(TenantContext);

  const handleSubmit = () => {
    const options = {
      method: method,
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${tokenAPI}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    };

    if (method === "POST") {
      axios
        .post(`${API_URL}${apiURL}/`, dataModal, options)
        .then(res => {
          if (auditEventType) {
            sendAuditEvent({
              token: tokenAPI,
              eventType: auditEventType,
              route: auditRoute || (typeof window !== "undefined" ? window.location.pathname : ""),
              entityIds: res?.data?.id ? [res.data.id] : [],
              tenantContext: tenant,
              metadata: {
                post_payload: auditMetadata || dataModal,
                created_id: res?.data?.id || null,
              },
            });
          }
          setSuccess(true);
          if (typeof onSuccess === "function") {
            onSuccess(res?.data);
          }
          if (setRedirect) {
            setToggleModal(false);
            setTimeout(() => setRedirect(true), 1000);
          } else {
            setToggleModal(false);
          }
        })
        .catch(err => {
          setError(true);
        });
    } else if (method === "PUT") {
      axios
        .put(`${API_URL}${apiURL}/`, dataModal, options)
        .then(res => {
          setSuccess(true);
          if (typeof onSuccess === "function") {
            onSuccess(res?.data);
          }
          if (setRedirect) {
            setToggleModal(false);
            setTimeout(() => setRedirect(true), 1000);
          } else {
            setToggleModal(false);
          }
        })
        .catch(err => {
          setError(true);
        });
    }
    else if (method === "PATCH") {
      axios
        .put(`${API_URL}${apiURL}/`, dataModal, options)
        .then(res => {
          setSuccess(true);
          if (typeof onSuccess === "function") {
            onSuccess(res?.data);
          }
          if (setRedirect) {
            setToggleModal(false);
            setTimeout(() => setRedirect(true), 1000);
          } else {
            setToggleModal(false);
          }
        })
        .catch(err => {
          setError(true);
        });
    }
  };
  return (
    <Modal isOpen={openModal} centered={true}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setToggleModal(false)}>
          Cancel
        </Button>
        <Button color="success" onClick={() => handleSubmit()}>
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalConfirm;
